module.exports = __webpack_public_path__ + "static/media/chevron-up-circle.943ec535.svg";